import { render, staticRenderFns } from "./equipment_camera.vue?vue&type=template&id=b56c510a&"
import script from "./equipment_camera.vue?vue&type=script&lang=ts&"
export * from "./equipment_camera.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports